import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TopBar, IconFacebook, IconLinkedIn, IconTwitter, IconEmail, Footer } from '../../components';
import Recaptcha from '../../components/Recaptcha/Recaptcha';
import MetaTags from 'react-meta-tags';

import { userActions } from '../../_actions';
import { updateValidators, resetValidators, displayValidationErrors, isFormValid } from '../../_helpers';

import './RegisterPage.css';

const RATE_LIMIT_WINDOW_MS = 30000;
const RATE_LIMIT_MAX_ATTEMPTS = 3;

class RegisterPage extends Component {
    submissionTimestamps = [];

    state = {
        user: {
            name: '',
            email: '',
            message: '',
        },
        submitted: false,
        divClass: 'registerContent',
        rateLimitMessage: '',
        recaptchaLoaded: false,
        validators: {
            name: {
                rules: [
                    {
                        test: (value) => Boolean(value && value.trim().length),
                        message: 'Name is required'
                    }
                ],
                errors: [],
                valid: false,
                state: '',
            },
            email: {
                rules: [
                    {
                        test: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: 'Please enter a valid email address'
                    }
                ],
                errors: [],
                valid: false,
                state: '',
            },
            message: {
                rules: [
                    {
                        test: (value) => Boolean(value && value.trim().length >= 10),
                        message: 'Message must be at least 10 characters'
                    }
                ],
                errors: [],
                valid: false,
                state: '',
            }
        },
    };

    componentDidMount(){
        this.fadeIn();
        resetValidators(this.state.validators);
    };

    fadeIn = () => {
        setTimeout(() => {
            this.setState({
                divClass: 'registerContent active'
            })
        }, 500);
    };

    handleRecaptchaLoaded = () => {
        this.setState({ recaptchaLoaded: true });
    };

    getRecaptchaToken = () => {
        return new Promise((resolve, reject) => {
            if (!window.grecaptcha) {
                reject('reCAPTCHA not loaded');
                return;
            }
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute('6Ld_gvkUAAAAAEN2c3myjc2H9C_6EwiPDgENT5GJ', { action: 'contact_form' })
                    .then(token => resolve(token))
                    .catch(err => reject(err));
            });
        });
    };


    handleChange = (event) => {
        const { name, value } = event.target;
        const { user } = this.state;
        this.setState({
            user: {
                ...user,
                [name]: value
            }
        });
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        this.setState({ submitted: true });
        const { dispatch } = this.props;
        const { user: { name, email, message } } = this.state;

        const now = Date.now();
        this.submissionTimestamps = this.submissionTimestamps.filter((ts) => now - ts < RATE_LIMIT_WINDOW_MS);
        if (this.submissionTimestamps.length >= RATE_LIMIT_MAX_ATTEMPTS) {
            this.setState({ rateLimitMessage: 'Please wait a moment before sending another message.' });
            return;
        }

        this.setState({ rateLimitMessage: '' });

        const formValues = { name, email, message };

        for (var key in formValues) {
            if (formValues.hasOwnProperty(key)) {
                updateValidators(this.state.validators, key, formValues[key]);
            }
        };

        if(isFormValid(this.state.validators)) {
            try {
                const token = await this.getRecaptchaToken();
                dispatch(userActions.register(name, email, message, token))
                    .then(() => {
                        this.submissionTimestamps.push(now);
                    })
                    .catch(() => {
                        this.submissionTimestamps.push(now);
                    });
            } catch (error) {
                console.error('reCAPTCHA error:', error);
                this.setState({ rateLimitMessage: 'reCAPTCHA verification failed. Please try again.' });
            }
        }
    };

    render() {
        const { history, registered, registerError  } = this.props;
        const { user, submitted, rateLimitMessage } = this.state;
        return (
            <div className={this.state.divClass}>
                <MetaTags>
                    <title>Entertainment Intelligence | Contact</title>
                    <meta name="description" content="Entertainment Intelligence" />
                    <meta property="og:title" content="Entertainment Intelligence" />
                    <meta property="og-image" content="./og-ei.jpg" />
                </MetaTags>
                <TopBar history={history} color={'black'} />
                <h2>Contact</h2>
                <div className="formHolder">
                    <h2 className="formTitle">Get in touch</h2>
                    {registerError ? (<div className='has-error has-error-big'>
                        {registerError}
                    </div>) : ('')}
                    {rateLimitMessage && (
                        <div className='has-error has-error-big'>
                            {rateLimitMessage}
                        </div>
                    )}
                    {(registered && !registerError) ? (
                        <div className='formSuccess'>
                            Thanks for reaching out! We'll be in touch shortly.
                        </div>
                    ) : (
                        <form className="Form" name="form" onSubmit={this.handleSubmit}>
                            <div className={'formGroup' + (submitted && !user.name ? ' hasError' : '')}>
                                <label className="formLabel" htmlFor="name">Name</label>
                                <input type="text" className="formControl" name="name" value={user.name} onChange={this.handleChange} />
                                { displayValidationErrors(this.state.validators, 'name') }
                            </div>
                            <div className={'formGroup' + (submitted && !user.email ? ' hasError' : '')}>
                                <label className="formLabel" htmlFor="email">Email</label>
                                <input type="text" className="formControl" name="email" value={user.email} onChange={this.handleChange} />
                                { displayValidationErrors(this.state.validators, 'email') }
                            </div>
                            <div className={'formGroup' + (submitted && !user.message ? ' hasError' : '')}>
                                <label className="formLabel" htmlFor="message">Message</label>
                                <textarea className="formControl formControlTextarea" name="message" value={user.message} onChange={this.handleChange} />
                                { displayValidationErrors(this.state.validators, 'message') }
                            </div>
                            <div className="formGroup">
                                <button className='Button' type="submit">Send message</button>
                            </div>
                            {/*<div className="iconsHolder">*/}
                            {/*    <a className='iconLink' target='_blank' href="https://www.facebook.com/EntertainmentIntelligenceLtd/">*/}
                            {/*        <IconFacebook />*/}
                            {/*    </a>*/}
                            {/*    <a className='iconLink' target='_blank' href="https://www.linkedin.com/company/entertainment-intelligence-ltd">*/}
                            {/*        <IconLinkedIn />*/}
                            {/*    </a>*/}
                            {/*    <a className='iconLink' target='_blank' href="https://twitter.com/ent_intell">*/}
                            {/*        <IconTwitter />*/}
                            {/*    </a>*/}
                            {/*    <a className='iconLink' href="mailto:disruptors@ent-intell.com">*/}
                            {/*        <IconEmail />*/}
                            {/*    </a>*/}

                            {/*</div>*/}
                        </form>
                    )}
                    <p className="recaptchaMessage">
                        This site is protected by reCAPTCHA <br />
                        and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a>
                        <br /> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                    </p>
                    <Recaptcha handleLoaded={this.handleRecaptchaLoaded} />
                </div>
                <Footer history={history} color={'black'} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { registering, registered, registerError } = state.registration;
    const { recaptcha } = state.contactUsForm;
    return {
        registering,
        registered,
        registerError,
        recaptcha,
    };
}

const connectedRegisterPage = connect(mapStateToProps)(RegisterPage);
export { connectedRegisterPage as RegisterPage };
